import { render } from "./Eleicoes2021.vue?vue&type=template&id=c86598a2&scoped=true"
import script from "./Eleicoes2021.vue?vue&type=script&lang=js"
export * from "./Eleicoes2021.vue?vue&type=script&lang=js"

import "./Eleicoes2021.vue?vue&type=style&index=0&id=c86598a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c86598a2"]])

export default __exports__